import _ from 'lodash';
import { find } from 'lodash/find'; /* eslint no-unused-vars: 0 */

class Geocoder {
  constructor() {
    this.geocoder = new google.maps.Geocoder();
  }

  formatAddress(addressComponents) {
    const country = _.result(
      _.find(addressComponents, component => {
        return (
          component.types[0] === 'country' && component.types[1] === 'political'
        );
      }),
      'long_name',
      ''
    );

    const postCode = _.result(
      _.find(addressComponents, component => {
        return component.types[0] === 'postal_code';
      }),
      'long_name',
      ''
    );

    const suburb = _.result(
      _.find(addressComponents, component => {
        return (
          component.types[0] === 'locality' &&
          component.types[1] === 'political'
        );
      }),
      'long_name',
      ''
    );

    const isNotAustralia = country !== 'Australia';

    if (isNotAustralia || !(postCode || suburb)) {
      return '';
    }

    return `${suburb}, ${postCode}, ${country}`;
  }

  getCurrentPosition() {
    return new Promise(resolve => {
      navigator.geolocation.getCurrentPosition(
        position => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        },
        error => {
          console.warn(
            'Geocoder :: Error while trying to get users current position. Probably user is not located in Australia.',
            error
          );
        }
      );
    });
  }

  getCurrentAddressFromLatLng(latLng) {
    const geocoderOptions = {
      location: latLng
    };

    return new Promise((resolve, reject) => {
      this.geocoder.geocode(geocoderOptions, (results, status) => {
        if (status === 'ZERO_RESULTS') {
          reject('Geocoder :: Google Maps API did not return any results');
        }

        if (status === 'INVALID_REQUEST') {
          reject(
            'Geocoder :: The query (address, components or latlng) is missing'
          );
        }

        if (status === 'OK') {
          const address = this.formatAddress(results[0].address_components);
          resolve(address);
        }

        reject('Geocoder :: Unknown error');
      });
    });
  }

  getCurrentAddress() {
    return this.getCurrentPosition().then(latLng => {
      return this.getCurrentAddressFromLatLng(latLng);
    });
  }
}

export default Geocoder;



// WEBPACK FOOTER //
// ./src/javascripts/Geolocation/Geocoder.js